import { formatDuration, tr } from '@app/i18n'
import { startBackRoute, stopFollow } from '../actions'
import { returnToCar } from '../car-actions'
import { arrivedAfterS, langTick, parkedCar } from '../state'
import { GLYPH_CAR } from './glyphs'

/** «Вы на месте»: зелёный чек + конфетти (однократно), обратный путь/машина. */
export function ArrivedPanel() {
  langTick.value
  const tookS = arrivedAfterS.value
  const car = parkedCar.value

  return (
    <section class="sheet">
      <div class="arrived-head">
        <div class="arrived-check">
          ✓<i />
          <i />
          <i />
          <i />
        </div>
        <h2 class="arrived-title">{tr('follow.arrived')}</h2>
        {tookS !== null && tookS >= 30 && (
          <p class="arrived-sub">{tr('follow.arrived_in', { time: formatDuration(tookS) })}</p>
        )}
      </div>
      <div class="btn-row">
        <button type="button" class="btn-secondary" onClick={car ? returnToCar : startBackRoute}>
          {car ? (
            <>
              <span
                class="glyph"
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: GLYPH_CAR }}
              />{' '}
              {tr('car.return')}
            </>
          ) : (
            `↩ ${tr('follow.back_route')}`
          )}
        </button>
        <button type="button" class="btn-primary" onClick={stopFollow}>
          {tr('common.done')}
        </button>
      </div>
    </section>
  )
}
